import React, { useState } from 'react';
import { Wrapper } from './styles';
import Agreement from '../Agreement';
import Contract from '../Contract';
import api from '../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { navigationUrl } from '../../store/analytic/actions';

const ContractAgreementList: React.FC = () => {
  const [aceptedBefore, setAceptedBefore] = useState<boolean>(true);
  const [acceptedlocalStorage, setAcceptedlocalStorage] = React.useState<
    boolean
  >(() => {
    return window.localStorage.getItem('acceptedCookies') === 'Y';
  });

  const dispatch = useDispatch();

  const token = useSelector((state: ApplicationState) => state.auth.token);

  async function getAceptedDate() {
    if (token) {
      const res = await api.getPoliticaPrivacidadeDataAceite();
      setAceptedBefore(res.data.getPoliticaPrivacidadeDataAceite !== null);
    }
  }

  React.useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/autenticou',
      })
    );
  }, [dispatch]);

  React.useEffect(() => {
    getAceptedDate();

    if (aceptedBefore === false && acceptedlocalStorage === true) {
      api.setPoliticaPrivacidadeDataAceite();
    }
  }, [aceptedBefore, acceptedlocalStorage]);

  return (
    <Wrapper>
      <Contract />
      <Agreement />
    </Wrapper>
  );
};

export default ContractAgreementList;
